// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"57bc6a53","206":"b6213b9f","272":"813f00fd","838":"3e35446f","979":"c0655c2c"}[chunkId] + ".css";
};